export default function List({ sponsors }) {
	return (
		<>
			{sponsors.map((data) => {
				return (
					<>
						<h3 key={data.name}>{`${data.name} Sponsors`}</h3>
						{data.logo ? (
							<div className="bfc-sponsor-tier-three">
								<ul>
									{data.items.map((item) => {
										return (
											<li>
												{item.imgUrl ? (
													<img src={item.imgUrl} alt={item.name} />
												) : (
													<span>{item.name}</span>
												)}
											</li>
										);
									})}
								</ul>
							</div>
						) : (
							<ul className="columns-two">
								{data.items.map((item) => {
									return <li key={item.id}>{item.name}</li>;
								})}
							</ul>
						)}
						<div className="list-spacer"></div>
					</>
				);
			})}
		</>
	);
}
